import React from 'react'
import { Route } from 'react-router-dom'
import { Grid } from '@softwaredev_cegeka/stix-core'
import Breadcrumb from 'src/components/Breadcrumb'

// Wrap router for passing props to child components.
export class ContentRoute extends React.Component {
    state = {
        Component: null,
    }

    loadRoute(routeName) {
        import(`${routeName}`)
            .then(module => {
                this.setState({ Component: module.default })
                localStorage.setItem('import-fail-count', '0')
            })
            .catch(ex => {
                console.error(ex)
                const failCount =
                    parseInt(localStorage.getItem('import-fail-count'), 10) || 0
                if (failCount > 2) {
                    throw ex
                }
                // Reload the current page when a chunk fails to load.
                // This can happen when a deploy created a new build, and a certain chunk don't match or doesn't exist anymore. Resulting in a syntax error.
                localStorage.setItem('import-fail-count', failCount + 1)
                window.location.reload()
            })
        return null
    }

    render() {
        const { component, path, breadcrumbs, name, title } = this.props
        const Component = this.state.Component
        return (
            <Route
                path={path}
                exact
                render={routeProps => {
                    return (
                        <div
                            className={`page-body stix-container-xxl route-${name}`}
                        >
                            <div className={'page-header-wrapper'}>
                                <Grid.Container>
                                    <div className={'content-route-header'}>
                                        <div className="content-route-header-title">
                                            <Breadcrumb
                                                breadcrumbs={breadcrumbs}
                                                path={path}
                                                {...routeProps}
                                            />
                                            <h1 className={'content-title'}>
                                                {title instanceof Function
                                                    ? title(
                                                          routeProps?.match
                                                              ?.params
                                                      )
                                                    : title}
                                            </h1>
                                        </div>
                                        <div
                                            id="page-action-portal"
                                            className="content-route-header-action"
                                        />
                                    </div>
                                </Grid.Container>
                            </div>
                            <Grid.Container>
                                {Component ? (
                                    <Component
                                        path={path}
                                        routeName={name}
                                        {...routeProps}
                                    />
                                ) : (
                                    this.loadRoute(component)
                                )}
                            </Grid.Container>
                        </div>
                    )
                }}
            />
        )
    }
}
